export default __webpack_public_path__ + "static/media/bs_img3.12365f3e.jpg";